import { useEffect, useState } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useIsProjectsEnabled } from './useIsProjectsEnabled';

const useQuickLinks = (componentId, experienceSSRData) => {
  const { data, loading, error } = useDataModel('quickLinks', {
    variables: {
      id: componentId
    },
    ssr: false,
    skip: experienceSSRData && experienceSSRData?.length > 0,
    // TODO: remove this once @apollo/client has been updated within data-sources v27
    // or we are ready to use data-sources v28
    //
    // This is a temporary fix, due to the fact that the `useQuery` from apollo/client has a bug
    // that was preventing us from fetching the data normally.
    //
    // In production, we should still be passing the data from SSR from my-homepage.
    fetchPolicy: 'network-only'
  });

  const [links, setLinks] = useState();
  const { hasProjectBenefit } = useIsProjectsEnabled();

  useEffect(() => {
    if (experienceSSRData !== undefined) {
      setLinks(experienceSSRData);
      return;
    }

    const { linkList } = data?.component || {};
    if (linkList) {
      setLinks(linkList);
    }

  }, [data, experienceSSRData, loading]);

  useEffect(() => {
    // if the user has project benefits and the "Projects" link is not already present, add it
    if (hasProjectBenefit && links && !(links.find((link) => link.label === 'Projects'))) {
      const newLink = {
        id: 'Projects',
        href: '/projects',
        label: 'Projects',
      };

      setLinks((prevLinks) => {
        let newLinks = [...prevLinks];
        newLinks.splice(2, 0, newLink);
        return newLinks;
      });
    }
  }, [hasProjectBenefit, links]);

  return { links, setLinks, loading };
};

export default useQuickLinks;